export default __webpack_public_path__ + "static/media/courseMobile.82c078e9.png";